import { useEffect } from "react";
import { Space, } from 'antd';
import { MarkdownContent } from '../../components/MarkdownContent';
import { CopyToClipboard } from '../../components/CopyToClipboard';
// Code blocks? https://github.com/rajinwonderland/react-code-blocks
// const commonStyles = {padding: '0 50px 50px', maxWidth: "1200px"}
const commonStyles = {maxWidth: "1200px"}
const fancyStyles = {fontSize: '0.9rem', fontFamily: 'Noto Serif, serif', ...commonStyles}
const regularStyles = {fontSize: '1.0rem', ...commonStyles}


const getPageMarkdownContent = (markdown: string, additional_page_content_styles?: React.CSSProperties) => {
    const styles = additional_page_content_styles ? additional_page_content_styles : regularStyles

    return (
        <div className="App">
          <div className="App-content">
            <div className="App-page-content" style={styles}>
                <div style={{position: 'relative'}}>
                    <div style={{position: 'absolute', top: '4px', right: '0'}}>
                        <CopyToClipboard text={markdown} content={<a style={{fontSize: '0.8rem'}}>Copy Markdown</a>} />
                    </div>
                    <MarkdownContent markdown={markdown} linkHeaders={true} />
                </div>
            </div>
          </div>
        </div>
      );
}

export function AffiliateContent() {
    const markdown = `# Affiliate
## How does it work?
When someone subscribes to PyroPrompts PRO using your affiliate link you earn a commission
The commission is 30% of the subscription price on all subsequent subscriptions
Your affiliates must subscribe to PyroPrompts PRO within 90 days from the initial visit of the affiliate link.

Payments are made monthly via bank wire transfer, check, PayPal or crypto.

When your balance exceeds $100 for the first time you will be contacted by the PyroPrompts Team to arrange your payment.

To get an affiliate link, please [contact us](/contact_us) or connect with our [community](/community).
`
    useEffect(() => {document.title = 'PyroPrompts | Affiliate'}, [])
    return getPageMarkdownContent(markdown)
}

export function UpdatesContent() {
    const markdown = `# Updates

A non-comprehensive non-exact list of PyroPrompts releases and updates.

## November 2023
- Projects and Workflows Generally Available
- Credits Released
- LemonSqueezy Integration for improved non-US support

## October 2023
- Workflow Experiences

## September 2023
- Chrome Extension
- Store Released
- Feedback Workflow
- Automation Recommendation Workflows

## August 2023
- Workflow AI Automation Open Beta
- Workflow Projects

## July 2023
- Workflow AI Automation Closed Beta
- Basic Workflows

## June 2023
- Prompt Templates
- New Themes Launched
- Search Functionality

## May 2023
- Prompt Tags
- Tag Pages
- User Pages

## April 2023
- PyroPrompts Launched
- Prompt Guide 2023

`
    useEffect(() => {document.title = 'PyroPrompts | Updates'}, [])
    return getPageMarkdownContent(markdown)
}

export function AdvertisingContent() {
    const markdown = `# Advertising
PyroPrompts is the destination for finding the most useful prompts and has thousands of visitors every week doing just that. Our users cross every domain subject and are technically savvy and usually willing to try new things.

We offer placements for traditional display advertisements, video advertisements and embedded advertisements along with targeting configurations.

We are also exploring AI Placements with our sister company, [Llamads](https://llamads.com).

If you are interested in advertising with us, please [contact us](/contact_us).
`
    useEffect(() => {document.title = 'PyroPrompts | Advertising'}, [])
    return getPageMarkdownContent(markdown)
}

export function IntegrationOfferings() {
    const markdown = `# Integrations

Data is at our core and it is our mission to make it easy to send and use data.

![Integrations](img/integrations.png "freqsignal integrations")

### No-Code Solutions

PyroPrompts can easily receive real-time data directly from [Trading View](/trading_view_webhook) or data can be uploaded manually in the web-application, no-code required.

PyroPrompts can distribute the data directly to [Telegram](/telegram_bot) or [Discord](/discord_bot) or [Email notifications](/email_bot). And the data can always be reviewed in the web-application and sent manually to these destinations.

If you're interested in submitting data from or sending a notification to another platform, let us know!

### Code Solutions

Find our [documentation here](/documentation) for how to submit data using our Token-based OAuth Integration.

Find our [pyroprompts-client python library](https://github.com/pyroprompts/pyroprompts-client) and [pyroprompts-client package on pypi](https://pypi.org/project/pyroprompts-client/) for easy submission from python-based solutions.

Find [sample strategies](https://github.com/pyroprompts/pyroprompts-strategies) show how to submit data from [Freqtrade](https://www.freqtrade.io/en/stable/), a popular cryptocurrency trading bot platform.

PyroPrompts also supports ingesting data from Amazon Web Services and distributing data to Amazon Web Services. We support the following AWS Services: S3, SQS, SNS, Firehose. Reach out to us to discuss this option, it can not be configured in the UI currently.

### Workflows

PyroPrompts manages all of the routing of data from your data subscriptions to your data destinations with [Workflows](/workflows). We can host and route your own private data or route free and paid data sets. Or, you can allow others to subscribe to your data. In some cases, PyroPrompts buys data with the intent to use and redistribute, [contact us](/contact_us) if you're interested in providing data.
`
useEffect(() => {document.title = 'PyroPrompts | Integration Offerings'}, [])
    return getPageMarkdownContent(markdown)
}

export function TermsConditionsContent() {
    const markdown = `# Terms and Conditions
These terms and conditions outline the rules and regulations for the use of PyroPrompts's Website, located at https://PyroPrompts.com.

By accessing this website we assume you accept these terms and conditions. Do not continue to use PyroPrompts if you do not agree to take all of the terms and conditions stated on this page.

The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements: "Client", "You" and "Your" refers to you, the person log on this website and compliant to the Company’s terms and conditions. "The Company", "Ourselves", "We", "Our" and "Us", refers to our Company. "Party", "Parties", or "Us", refers to both the Client and ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting the Client’s needs in respect of provision of the Company’s stated services, in accordance with and subject to, prevailing law of Netherlands. Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same.
## Disclaimer

Any and all ideas expressed, research, tutorials, and instructional resources are for educational purposes only. The ideas expressed are solely the opinions of PyroPrompts.

Content provided by users does not reflect the opinion of PyroPrompts.

Your use of ideas, systems, and/or data provided by PyroPrompts are at your own risk and it is your sole responsibility to evaluate the accuracy, completeness, and usefulness of the information.

## Cookies

We employ the use of cookies. By accessing PyroPrompts, you agreed to use cookies in agreement with the PyroPrompts's Privacy Policy. Most interactive websites use cookies to let us retrieve the user’s details for each visit. Cookies are used by our website to enable the functionality of certain areas to make it easier for people visiting our website. Some of our affiliate/advertising partners may also use cookies.

## License

Unless otherwise stated, PyroPrompts and/or its licensors own the intellectual property rights for all material on PyroPrompts. All intellectual property rights are reserved. You may access this from PyroPrompts for your own personal use subjected to restrictions set in these terms and conditions. You must not: Republish material from PyroPrompts Sell, rent or sub-license material from PyroPrompts Reproduce, duplicate or copy material from PyroPrompts Redistribute content from PyroPrompts This Agreement shall begin on the date hereof. Parts of this website offer an opportunity for users to post and exchange opinions or Prompts and information in certain areas of the website, referred to as User Contributed Content. User Contributed Content includes Account Profiles, Prompts, Comments, Direct Messages, Workflows, Integrations and Dashboards. PyroPrompts does not filter, edit, publish or review User Contributed Content prior to their presence on the website. User Contributed Content do not reflect the views and opinions of PyroPrompts, its agents and/or affiliates. User Contributed Content reflect the views and opinions of the person who post their views and opinions. To the extent permitted by applicable laws, PyroPrompts shall not be liable for the User Contributed Content or for any liability, damages or expenses caused and/or suffered as a result of any use of and/or posting of and/or appearance of the User Contributed Content on this website. PyroPrompts reserves the right to monitor all User Contributed Content and to remove any User Contributed Content which can be considered inappropriate, offensive or causes breach of these Terms and Conditions. You warrant and represent that: You are entitled to post the User Contributed Content on our website and have all necessary licenses and consents to do so; The User Contributed Content do not invade any intellectual property right, including without limitation copyright, patent or trademark of any third party; The User Contributed Content do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful material which is an invasion of privacy. You hereby grant PyroPrompts a non-exclusive license to use, reproduce, edit and authorize others to use, reproduce and edit any of your User Contributed Content in any and all forms, formats or media.

## iFrames

Without prior approval and written permission, you may not create frames around our Webpages that alter in any way the visual presentation or appearance of our Website.

## API

Without an API integration or prior approval and written permission, you may not use the API directly. Use of the PyroPrompts service must be through the PyroPrompts.com website.

## Warranties

Neither PyroPrompts, its Agencies, Attorneys, Members, Affiliates, nor any Content Partner makes any warranty or representation that the Information is accurate and timely. You understand that use of the Site and of the Products is undertaken at Your own risk. Any information or data provided by PyroPrompts is not exhaustive or complete.

## Your Privacy

We respect your privacy rights! We will not sell or distribute your email address or other information without your express consent. We also do not store your any of your credit card information. Only PyroPrompts, our Agencies, Attorneys, and Partners are entitled to your information.

## Abuse of Payment Systems

You are entitled to ONE free trial period. Our system automatically checks if you have already signed up for a free trial. If it is found that you are abusing the free trial system, your card will be charged right away and you will be converted to a full subscription instead of availing the trial.

## Credits

Credits may be redeemed to access certain capabilities or services ("Services") offered by PyroPrompts. The number of Credits required to access Services will be determined by PyroPrompts and may vary depending on the complexity, tier or category of the Service selected.

Credits are not a monetary instrument, and they do not have a cash value. They cannot be redeemed for cash or converted into monetary funds. Credits are only a means to gain access to PyroPrompts's Services. Credits purchased are non-transferable and cannot be sold or exchanged. All purchases of Credits are final. Credits are non-refundable once purchased, except in the circumstances required by law.

Credits may expire if not used within a certain period of time, as determined by PyroPrompts and communicated to you. PyroPrompts reserves the right to deactivate or terminate your ability to use the Credits after the expiration period.

PyroPrompts reserves the right to modify, suspend, or discontinue any aspect of the Services at any time, including the availability of any Service feature, database, or content. PyroPrompts may also impose limits on certain Services or restrict your access to parts or all of the Services without notice or liability.

You are responsible for all activities that occur under your account, including the purchase and use of Credits. PyroPrompts is not responsible for unauthorized access to your account or misappropriation of Credits.

### Promotional Credits

From time to time, PyroPrompts may grant credits for promotional purposes or as a reward for certain activities or behaviors ("Promotional Credits"). These Promotional Credits are subject to the same terms and conditions as purchased Credits but may have additional restrictions as communicated at the time of the offer.

Promotional Credits may be awarded to your account for participating in certain promotions, completing specified tasks, or as part of a customer loyalty or rewards program. The amount and value of Promotional Credits, and the tasks or actions required to earn them, will be determined by PyroPrompts and communicated in the promotional offer.

Promotional Credits can be used in the same manner as purchased Credits within the service offerings of PyroPrompts, unless otherwise specified in the terms of the promotion.

PyroPrompts reserves the right to revoke or remove Credits, including Promotional Credits, from your account if PyroPrompts determines, in its sole discretion, that the Credits were obtained fraudulently, unlawfully, or in violation of these Terms and Conditions. PyroPrompts also reserves the right to take any necessary legal action in response to fraud or illegal activities associated with the accrual or use of Credits.

Promotional Credits have no cash value, are not redeemable for cash, and cannot be returned or refunded, except in the circumstances required by law or as expressly permitted by these Terms and Conditions.

Promotional Credits may have expiration dates, and you must use them before the expiration date. The expiration date for each Promotional Credit issuance will be clearly communicated in the associated promotion. Unused Promotional Credits will expire and will be removed from your account after the expiration date.

PyroPrompts may modify, suspend, or terminate any promotional offer at any time without prior notice. In the event a promotional offer is terminated, any unused Promotional Credits related to the offer may also be revoked or expire immediately.

## Email Newsletters

When you sign up with an account, you are automatically enrolled in our email newsletter service. If you wish to cancel it, you can either click unsubscribe to the email newsletter in your inbox, or go to your profile and unclick the email checkbox. Newsletters are sent with different frequencies.

## Refund Policy

If you are under a free trial period, you will be charged at the end of your trial unless cancelled. We do not provide refunds. All sales are final. it is your responsibility to manage your subscription accordingly. You may your cancel subscription at any time by clicking on the circle at the top of the website and going to your profile.

## Reservation of Rights

We reserve the right to request that you remove all links or any particular link to our Website. You approve to immediately remove all links to our Website upon request. We also reserve the right to amen these terms and conditions and it’s linking policy at any time. By continuously linking to our Website, you agree to be bound to and follow these linking terms and conditions.

## Removal of links from our website

If you find any link on our Website that is offensive for any reason, you are free to contact and inform us any moment. We will consider requests to remove links but we are not obligated to or so or to respond to you directly. We do not ensure that the information on this website is correct, we do not warrant its completeness or accuracy; nor do we promise to ensure that the website remains available or that the material on the website is kept up to date.
    `
    useEffect(() => {document.title = 'PyroPrompts | Terms and Conditions'}, [])
    return getPageMarkdownContent(markdown, fancyStyles)
}

export function PrivacyPolicyContent() {
    const markdown = `# PRIVACY POLICY FOR INFORMATION USE AT PYROPROMPTS.COM

PyroPrompts.com, ("We") are committed to maintaining the privacy of personal information that you provide to us when using the PyroPrompts.com web site. This privacy policy describes how we treat personal information received about you when you visit PyroPrompts.com.

## Personal Information We Collect

Personally identifiable information (“Personal Information”) is information that can be used to identify or contact you, such as your name, address, email address, telephone number or similar information. We only collect personal information on our web site that you choose to share with us, such as when:

- contacting us via the web site or email
- creating an user account
- creating personal content (prompts)
- making an online purchase, or subscription to a service
- interacting with our services

## How We Use Information Collected

We may use information in the following ways:

- For the purposes for which you specifically provided the information.
- To send you e-mail notifications about our new or existing products and services, special offers, or to otherwise contact you.
- To enhance existing features or develop new features, products and services.
- To provide advertisers and other third parties with aggregate information about our user base and usage patterns
- To deliver relevant content and recommendations
- To deliver advertising and interest-based advertising

Except as specifically stated in this privacy policy, we will not share your personally identifiable information with any third parties outside of PyroPrompts.com

## Security

The personally identifiable information is stored in our limited-access servers. We will maintain safeguards to protect the security of these servers and your personally identifiable information. Online purchases made through our web site are processed securely by Stripe.com or PayPal.com. When making a payment, we do not have access to credit card information.


## Links

We may make content or services from other web sites including our co-branded web sites available to you from links located on www.PyroPrompts.com. These other web sites are not subject to this privacy policy. We recommend that you review the privacy policy at each such web site to determine how that site protects your privacy.


## Cookies

Like many websites, this website sets and uses cookies to enhance your user experience — to remember your personal settings, for instance. Advertisements may display on this website and, if so, may set and access cookies on your computer; such cookies are subject to the privacy policy of the parties providing the advertisement. However, the parties providing the advertising do not have access to this site's cookies. These parties usually use non-personally-identifiable or anonymous codes to obtain information about your visits to this site.

For more information about this type of online advertising, about cookies, and about how to turn this feature off, please visit this link.

Please note that turning off advertising cookies won’t mean that you are not served any advertising, merely that it will not be tailored to your interests.


## Internet-based Transfers

Given that the internet is a global environment, using the internet to collect and process personal data necessarily involves the transmission of data on an international basis. Therefore, by browsing www.PyroPrompts.com and communicating electronically with us you acknowledge and agree to our processing of personal data in this way.


## Advertising

When you use our website, we share information that we collect from you, such as your email (in hashed form), IP address or information about your browser or operating system, with our identity partners/service providers.


## Privacy Notice For California Residents

This PRIVACY NOTICE FOR CALIFORNIA RESIDENTS supplements the information contained in the Privacy Statement of PyroPrompts.com (“PyroPrompts”, “we,” “us,” or “our”) and applies solely to visitors, users, and others who reside in the State of California (“consumers” or “you”). We adopt this notice to comply with the California Consumer Privacy Act of 2018 (“CCPA”) and other California privacy laws. Please follow the link to access PyroPrompts’s California Privacy Notice.


## Comments and Questions

If you have any questions, comments or concerns about our privacy policy, you may email us at support@PyroPrompts.com or use contact form.

    `
    useEffect(() => {document.title = 'PyroPrompts | Privacy Policy'}, [])
    return getPageMarkdownContent(markdown, fancyStyles)
}


export function CommunityContent() {
    const markdown = `# Community

We are a growing community of prompt engineers, automation gurus and ai enthusiasts sharing our experiments and our work.

Join our [Discord Server](pp_discord)

Keep conversation civil and respectful. We will not hesitate to ban anyone we feel is creating an unwelcoming environment. Keep it family friendly.

Guidelines:

1. Personal attacks and/or aggressive profanity directed at other members of the community will not be tolerated. Creating unnecessary conflict with other discord members will not be tolerated.
2. Sexually suggestive comments aimed at other members of the community are discouraged.
3. Profanity is allowed, but not when negatively directed at other people in the community.
4. Posting images or links containing sexually explicit material or graphic violence is not allowed.
5. Advertising businesses, discords, NFT's, YouTube channels, courses, communities, random crypto projects, or charities/fundraisers/non-profit organizations is not allowed.
6. Never give out private or personal information.

If you are interested in joining us or are looking to connect with the administrators, join our [Discord Server](pp_discord).

You can also just [contact us](/contact_us) if you're looking to get in touch.

   `
    useEffect(() => {document.title = 'PyroPrompts | Community'}, [])
    return getPageMarkdownContent(markdown)
}

export function ContactUsContent() {
    const markdown = `# Contact Us

## Support
For support or issues or feature requests, contact [support@pyroprompts.com](copy) or connect with us on Twitter / X @PyroPrompts. Please include any steps to reroduce your problem.

## General Communications
For most business communications such as public relations and marketing, partnership and advertising opportunities, or legal matters, please contact [info@pyroprompts.com](copy).

## Social
Find us on [Twitter / X @PyroPrompts](https://twitter.com/pyroprompts) or on [Reddit r/PyroPrompts](https://www.reddit.com/r/PyroPrompts/)


   `
    useEffect(() => {document.title = 'PyroPrompts | Contact Us'}, [])
    return getPageMarkdownContent(markdown)
}

export function DocumentationContent() {
    const markdown = `# Documentation

This knowledge base covers technical aspects of PyroPrompts and aims to clarify behavior and edge cases.

For support or issues, please contact [support@pyroprompts.com](copy), outlining your issue and steps to reproduce.

## Index
- [Terminology](#terminology)
- [How To](#how-to)
- [OAuth2 API Token Integration](#oauth2-api-token-integration)
- [Simple API Token](#simple-api-token)
- [Custom AI Chat Integrations](#custom-ai-chat-integrations)


## Terminology

### Prompt
- Prompts are stored in PyroPrompts and have the content that would be sent as a prompt to an AI.
- Prompts may be named and may have a description
- Prompts may be incomplete, with placeholders used where you would swap in use-specific content.
- You may see all Prompts created by yourself and public prompts created by anyone.
- Prompts may be deleted or made public after being created

### Username
- Your unique name for your account.
- If Prompts are shared, others will see this name.
- A Bio may be created with more information about a user/username
- A user may designate themelves as public, so they can be found via search

### Tag

- *Note: Coming soon*
- Tags are used to organize your personal library and are not visible to others.
- Tags can have a name, a color and a category

### Collection

- *Note: Coming soon*
- Collections are used to organize a curated set of Prompts
- Collections have a name and description
- Collections can have configurable access settings, limiting who can see the prompts
- Prompts in a Collection can be ordered

### Workflow

- Workflows are used to automate the execution of Prompts, Sending of Emails, Updating of Snippets
- Workflows have a Name and a Configuration
- Workflows are private, nobody outside of your account can see your Workflows
- Workflows can use Integrations to interact with external services.
- Workflows can be published as AI Apps

### Project

- Projects can be used to organize and isolate workflows.
- Projects can have Snippets of saved text to inject in to Steps in Workflows

### Integration

- Integrations can enable access to PyroPrompts by outside resources, like a coded script or Google Sheets
- Integrations can enable PyroPrompts to use outside resources, like sending prompt responses to an email or Slack Workflow or pulling data from a Google Sheet
- Integrations can have a name
- Integrations can be deleted

## How To

### Run a Prompt in ChatGPT

#### Copy Prompt
1. Click "Copy" under a Prompt to copy its Contents.
2. Open ChatGPT, select Model and any Plugins needed
3. Paste in Prompt

### Create a Prompt

1. Navigate to the Prompt Stream on the Home Page or in Browse or to your User's page
2. Click Create Prompt
3. Enter the Prompt Content
4. Name and Description are Optional
5. Click Create

### Create a Form Workflow

Form workflows can be triggered manually.

1. Navigate to the Projects Page
2. If you don't have a project yet or want a new project, create a new project
3. Navigate to desired Project Page
4. Create a Workflow
5. In the Workflow Configuration, configure your desired form and inputs.
6. Configure any Prompts to run, update any Snippets, send any Emails
7. Set the Workflow Result to be what you want visible after running the Workflow.

### Create a Timed Workflow

Form workflows can be triggered manually.

1. Navigate to the Projects Page
2. If you don't have a project yet or want a new project, create a new project
3. Navigate to desired Project Page
4. Create a Workflow
5. In the Workflow Configuration, select Timed for the Trigger Type
6. Configure if you want it to run Daily or Weekly or Monthly and when Weekly/Monthly it would run and what hour of the day to run.
7. Configure any Prompts to run, update any Snippets, send any Emails
8. Set the Workflow Result to be what you want visible after running the Workflow.

# Programmatic Integration

PyroPrompts is your place to host your AI systems. No servers (or serverless apps) to manage. Create an integration to get credentials to begin integrating.

## OAuth2 API Token Integration

All your data - prompts, projects, snippets, workflows, etc. in PyroPrompts is Secured by Oauth2.

The OAuth2 API Token provides a "Client ID" and a "Client Secret". These credentials are used to get an Access Token, which can be used for API Requests to fetch and submit data.

*Note*: Our Python Client can be installed with \'pip install pyroprompts-client\', available on [PyPi as pyroprompts-client](https://pypi.org/project/pyroprompts-client/).

### 1. Create Tokens

To get a token, login and navigate to the [integrations](/integrations) page. Create an "OAuth2 API Token" integration. Save the Client ID and Client Secret somewhere secure.

### 2. Get Access Token

Issue an HTTP \`POST\` Request to \`https://api.pyroprompts.com/oa2/token/\` with the following body (replacing \`CLIENT_ID\` and \`CLIENT_SECRET\` with your credentials from step 1):

    POST https://api.pyroprompts.com/oa2/token/
    Body:
        {
            "grant_type": "client_credentials",
            "client_id": "CLIENT_ID",
            "client_secret": "CLIENT_SECRET"
        }

The response's status code should be \`200\` and the response body should look like:

    {
        "access_token": "abcdefghijklmonpqrstuvwxyz",
        "expires_in": 36000,
        "scope": "read write",
        "token_type": "Bearer"
    }

The value in the \`access_token\` field is your Access Token.

### 3a. Trigger a Workflow

Some people want to trigger a Workflow in response to an event in another system - like a Zapier Zap or a Form Submission. You can run a Workflow in PyroPrompts programatically.

To kick off a Workflow in PyroPrompts, you may issue HTTP requests via your tool of choice.

Issue an HTTP \`POST\` Request to \`https://api.pyroprompts.com/api/workflow/trigger/\` with the \`Authorization\` header set to \`Bearer ACCESS_TOKEN\` (replace \`ACCESS_TOKEN\` with your Access Token):

    POST https://api.pyroprompts.com/api/workflow/trigger/
    Headers:
        Authorization: Bearer ACCESS_TOKEN
    Body:
        {
            "account_id": "YOUR_ACCOUNT_ID",
            "workflow_id": "WORKFLOW_ID",
            "workflow_form_params": {"param_1": "value_1"}
        }


- \`ACCESS_TOKEN\` is your Access Token from step 2
- \`YOUR_ACCOUNT_ID\` is the ID of your account, which can be found in the [account page](/account)
- \`WORKFLOW_ID\` is the ID of the workflow you want to execute, which can be found in the Project page when you click on a Workflow.
- \`workflow_form_params\` is an optional field to pass in any parameters for the workflow to use if it's form-based and accepts fields.


And a body like (replace \`WORKFLOW_ID\` with the Id of your Workflow you're triggering):

    {
        "account_id": "YOUR_ACCOUNT_ID",
        "workflow_id": "WORKFLOW_ID",
        "workflow_form_params": {"param_1": "value_1"}
    }


### 3b. Get Workflow Execution

After triggering a workflow, you may want to check back for the result if you rely on that. You may check the Workflow Executions endpoint.

Issue an HTTP \`GET\` Request to \`https://api.pyroprompts.com/api/crud/workflow_executions/?limit=10\` with the \`Authorization\` header set to \`Bearer ACCESS_TOKEN\` (replace \`ACCESS_TOKEN\` with your Access Token):

    GET https://api.pyroprompts.com/api/crud/workflow_executions/?limit=10
    Headers:
        Authorization: Bearer ACCESS_TOKEN

The response should be \`200\` and the body will be a paginated response looking like:

    {
        "count":1,
        "next":null,
        "previous":null,
        "results":[
            {
                "id":"1a7bae4f-f121-432b-b44e-abcdefg",
                "status":"complete",
                "status_message":null,
                "created_date":"2024-07-03T15:51:08.905236Z",
                "workflow_id":"ca00d56b-79bc-42b1-8e99-abcdefg",
                "result":"The response is in here",
                "form_params":null
            }
        ]
    }

Results are ordered by \`updated_date\`, with most recent updates first. Query parameters supported includes:

- \`id\`: the id of the workflow execution to return.
- \`offset\`: number of results to offset by, used in pagination
- \`workflow_id\`: filter to results from a specific workflow
- \`created_date__gt\`: filter to results created after a certain date

Requesting all of a single workflow's executions could look like this

    GET https://api.pyroprompts.com/api/crud/workflow_executions/?workflow_id=abcd-1234-cdfg-abcdefg

Requesting the second page of a workflow's executions could look like either of the following:

    GET https://api.pyroprompts.com/api/crud/workflow_executions/?workflow_id=WORKFLOW_ID&offset=10&limit=10
    GET https://api.pyroprompts.com/api/crud/workflow_executions/?workflow_id=WORKFLOW_ID&limit=10&created_date__gt=2022-11-03T00:20:04.677004Z

If you are running in a loop, it is a best practice to use the \`created_date__gt\` parameter to filter to just more recent than your most recent executions, stored locally.

3c. Get Snippets for a Project

You may want to use generated snippets in other projects or let ChatGPT have access to Snippets so it can know more automatically about what you're working on. You can get the Snippets via the API.

    GET /api/crud/project_snippets/?project_id=abcd-1234-cdfg-abcdefg&limit=100&ordering=name
    Headers:
        Authorization: Bearer ACCESS_TOKEN

The response should be \`200\` and the body will be a paginated response looking like:

    {
        "count": 2,
        "next": null,
        "previous": null,
        "results": [
            {
                "id": "3d1daced-ce1d-4232-9b39-abcdefg",
                "name": "Snippet1",
                "description": null,
                "content": "Content of Snippet1",
                "project_id": "e95d56f8-72d1-4b13-bc5d-abcdefg",
                "deleted": 0,
                "created_by": "454517f4-a97e-45a7-8088-abcdefg",
                "created_date": "2024-07-03T15:38:14.387627Z",
                "updated_date": "2024-07-03T15:38:14.387645Z"
            },
            {
                "id": "f54049ee-266f-4fd7-a2f6-abcdefg",
                "name": "Snippet2",
                "description": null,
                "content": "Content of Snippet2",
                "project_id": "e95d56f8-72d1-4b13-bc5d-abcdefg",
                "deleted": 0,
                "created_by": "454517f4-a97e-45a7-8088-abcdefg",
                "created_date": "2024-07-03T15:45:49.697119Z",
                "updated_date": "2024-07-03T15:51:04.722434Z"
            },

        ]
    }

[Learn more about OAuth2](https://oauth.net/2/grant-types/client-credentials/)


## Simple API Token

The Simple API Token is only available to use to upload to Data Sets, but that is still in Beta, so if you are not in the Beta program, [contact us](/contact_us) to get access or wait for the full release. Reading must be done with the Oauth2 API Token Integration (above).

## Custom AI Chat Integrations

PyroPrompts supports adding your own AI integrations if the service supports the OpenAI interface: \`\{base_url\}/chat/completions\`

This will avoid any LLM costs through PyroPrompts and opens you up to use any compatible LLM service, like Groq, Perplexity, xAI and many more. Check back for more details and a larger list of supported providers.

## Outro

We are updating this page regularly with new definitions and documentation.
   `
    useEffect(() => {document.title = 'PyroPrompts | Documentation'}, [])
    return getPageMarkdownContent(markdown)
}

export function WorkflowAutomationContent() {
    const markdown = `# Workflow Automation

Workflows automate your systems and frameworks with AI, saving you time and formalizing how you use powerful LLMs.

- No more copying and pasting prompts
- No more needing to remember to run some prompts every day or week
- No more forgotten AI

Multiply your work with AI Workflows and Projects.

## What You Can Do

Workflows are built to be as flexible as possible, enabling new actions and integrations that are easily configurable. Some common uses:

1. Content Creation for Websites, Social Media, Blogs, Newsletters, etc
2. Comparing Prompt Responses for Prompt Optimization
3. Personalized Note Taker
4. Monitoring what AI knows about a specific subject
5. Generating customized lesson plans, workout plans, business plans
6. Batch AI Processing

We also publish a number of [Public Workflows](/workflows) for you to use.

   `
    useEffect(() => {document.title = 'PyroPrompts | Workflow Automation'}, [])
    return getPageMarkdownContent(markdown)
}

export function AiMonitoringContent() {
    const markdown = `# AI Monitoring

Automatically ask AI prompts, track the responses over time, get alerted on changes.


## Brand Monitoring

- What does AI know about you or your brand?
- Are you included in the "search results" when prompting for related topics?
- Are your competitors showing up?
- What kind of sentiment does AI have for your brand?
- What can you do to improve your content for AI Optimization?


## Knowledge Checking

- How long does it take AI to know about something?
- How can we get AI informed about topics I think are important?


## Prompt Response Stability

- Given the same prompt, how stable is AI's response?
- What are the common themes? What has changed over time?


   `
    useEffect(() => {document.title = 'PyroPrompts | AI Monitoring'}, [])
    return getPageMarkdownContent(markdown)
}


export function ConsultingContent() {
    const markdown = `# AI Consulting & Custom Development

We help businesses and individuals to adopt AI in product and operations through guides, lessons, consultation and custom development.

AI moves fast. So should you.

*Note:* We have limited remaining availability for consultation through the end of 2023. Don't miss out, [contact us](/contact_us) today.

## Services

We offer short and long term engagements to help you execute on your AI goals.

- **We build for you:** We'll work to understand your goals and the requirements and we'll build for you.
- **We build with you:** We can lead a project, familiarizing your team, or add additional capacity to your team.
- **We advise you:** You're building, we are there to discuss, debug, plan and help ensure success.

## Capabilities

We provide services in the following areas and can support more for the right project.

### GPT and Assistants Development

We can build GPTs or Assistants for you or with you or just advise on the process and the emerging best practices.

### Prompt Engineering
Get the right response from Prompt-Based LLMs. Reference the [Prompt Guide](/prompt_guide_2023) for all the tips and tricks or accelerate your improved prompts by bringing on a PyroPrompts expert.

### LangChain Integration
Our engineers contribute to LangChain and follow developments very closely. We can help you integrate AI into your product or business operations.

### Embeddings
Represent text with Embedding Vectors for semantic lookups and improved search.

### Non-LLM AI
PyroPrompts engineers have considerable experience working with Statistical, Regression, Classification and many other Artificial Intelligence and Machine Learning models. Most of the team have worked in these fields prior to the AI LLM advancements. PyroPrompts can help with processing and cleaning data sets, training, train-optimization, visually representing results, integrating into production workflows.


**Don't wait**, we are planning projects *now*. [Contact us](/contact_us) and secure your spot today.


   `
    useEffect(() => {document.title = 'PyroPrompts | AI Consulting'}, [])
    return getPageMarkdownContent(markdown)
}

export function CompanyContent() {
    const editedMarkdown = `# Company

Established during the wave of AI technologies following OpenAI's ChatGPT breakthrough in 2023, Matt Ferrante was inspired by the potential of this technology. Dissatisfied with manually running, managing and sharing prompts, he started PyroPrompts as the go-to solution for optimizing and automating these processes. Our mission at PyroPrompts is to empower individuals and businesses to navigate and stay at the forefront of this AI-centric landscape. We firmly believe that this ongoing transition from the Information Age to the Knowledge Age will continue to disrupt industries, driving technological advancement throughout the 2020s and beyond. PyroPrompts is committed to being an active contributor to the transformative impact of this technology.

[info@pyroprompts.com](copy)

## Careers
PyroPrompts operates as a fully remote company located in the United States.

We are not actively hiring at this time. However, if you are interested in contributing in any capacity, please feel free to [contact us](/contact_us).

## Investors
PyroPrompts is fully bootstrapped and not seeking investment at this time. If you consider yourself a strategic partner and are interested in getting involved, please [contact us](/contact_us).

    `
    const markdown = `# Company

Founded during the wave of new AI technologies in response to OpenAI's ChatGPT breakthrough in 2023, Matt Ferrante was awe-struck by the possibilities and wanted a better way to manage, share and automate all his prompts, searching through the ChatGPT conversations and copying prompts wasn't cutting it. PyroPrompts was created to help improve prompts and the interaction with them. PyroPrompts aims to help people navigate and stay ahead of this new AI-focused landscape. We believe this shift from the Information Age to the Knowledge Age will continue to be disruptive and drive technical growth throughout the 2020s and beyond. PyroPrompts is committed to contributing to the impact this technology will have.

[info@pyroprompts.com](copy)

## Careers
PyroPrompts is a fully remote company primarily located in the United States.

PyroPrompts is not actively hiring at this time. If you would like to be involved in some capacity, [contact us](/contact_us).

## Investors
PyroPrompts is funded and not actively looking for investment. If you would like to be involved and would consider yourself to be a strategic partner for us, [contact us](/contact_us).

   `
    useEffect(() => {document.title = 'PyroPrompts | Company'}, [])
    return getPageMarkdownContent(editedMarkdown)
}


export function CustomGPTsContent() {
    const markdown = `# Custom GPTs

OpenAI introduced Custom GPTs on November 6th, 2023, at the same time they announced Assistants. [See OpenAI's Blog Post](https://openai.com/blog/introducing-gpts).

We have a number of Custom GPTs, some are based on the [Workflows](/workflows) we have published.

### PyroPrompts GPTs

Here is an incomplete list of our GPTs:

#### Business

- **[Super Solutions](https://chat.openai.com/g/g-KRegNHxWj-super-solutions):** List some problems, I'll flip the script and frame them as solutions you can offer.
- **[OpenAI's Business Pivoter](https://chat.openai.com/g/g-WrdNxYeIk-ai-wrapper-business-pivoter):** OpenAI ate AI Wrapper's Lunches. Now, ask OpenAI what you should pivot to.
- **[Perfect Landing Pages](https://chat.openai.com/g/g-hbyqqOpn5-pyropages-perfect-landing-pages):** Get landing page copy that converts.
- **[Interview with Skip Stone](https://chat.openai.com/g/g-uCCcObpt0-interview-with-skip-stone):** Get interviewed! Great for content creation.
- **[Dream Customer Identifier](https://chat.openai.com/g/g-xD3TVioaD-dream-customer-identifier):** Help me determine my dream customer.
- **[Niche Finder](https://chat.openai.com/g/g-kyD1GRE6a-niche-finder):** Help me focus in on my ideal Niche.


#### AI and Prompting

- **[Easy OpenAPI Actions Spec](https://chat.openai.com/g/g-V5nO8MMRp-easy-openapi-actions-spec):** Help with getting OpenAPI Actions Spec
- **[PyroPrompts Prompt Crafter](https://chat.openai.com/g/g-OwKMYCRpS-pyroprompts-craft-blazing-prompts):** Help crafting great prompts
- **[Custom GPT Promo Instructions](https://chat.openai.com/g/g-DD2mdmZG2-custom-gpt-promo-instruction):** Create instructions for a Custom GPT to mention you.


#### Lifestyle

- **[Best Summer Ever Assistant](https://chat.openai.com/g/g-wKBD0YEmZ-best-summer-ever-assistant):** Make memories, not plans.
- **[Gift Whisperer](https://chat.openai.com/g/g-TdzZSZMGa-gift-whisperer):** Figure out gifts for people.
- **[Santa's Secretary](https://chat.openai.com/g/g-Z6frbDHlH-santa-s-secretary):** Get a letter from Santa!


#### Games

- **[DnD Game Map Cartographer](https://chat.openai.com/g/g-ftWpL3JwT-game-map-cartographer):** Create maps for DnD or other games.
- **[DnD TTRPG GPT](https://chat.openai.com/g/g-IVwKcgydL-ttrpg-gpt):** Run a solo dungeons and dragons style game.
- **[Secret Code Guardian](https://chat.openai.com/g/g-bn1w7q8hm-secret-code-guardian):** Try to crack the code in this game.


#### Friends

- **[Birth Pasta](https://chat.openai.com/g/g-4IkgK9EBl-birth-pastafarian):** Fun twist on horoscopes, but with pasta!


#### Other
- **[Technical Analysis GPT](https://chat.openai.com/g/g-Ult84NCPF-ta-gpt):** Ask questions about technical analysis.
- **[Floral Muse](https://chat.openai.com/g/g-udwJnpKXr-floral-muse):** Create beautiful flowing flowery images.
- **[Images to Text](https://chat.openai.com/g/g-zCyUnCmek-images-to-text):** Use GPT-Video to extract text from images
- **[Debate me, bro](https://chat.openai.com/g/g-Ogjv0wiC6-debate-me-bro):** Identify logical flaws in arguments.
- **[Web Design Starter](https://chat.openai.com/g/g-Zgb0XAtsX-instant-web-design-starter):** Get a web site starter page


### Custom GPT Development

We can help with developing your Custom GPT. [Contact us](/contact_us) if you'd like to learn more.

   `
    useEffect(() => {document.title = 'PyroPrompts | Custom GPTs'}, [])
    return getPageMarkdownContent(markdown)
}


export const content_pages = {
    advertising: AdvertisingContent,
    contact_us: ContactUsContent,
    documentation: DocumentationContent,
    // enterprise: EnterpriseContent,
    privacy: PrivacyPolicyContent,
    terms_conditions: TermsConditionsContent,
    workflow_automation: WorkflowAutomationContent,
    ai_monitoring: AiMonitoringContent,
    consulting: ConsultingContent,
    company: CompanyContent,
    updates: UpdatesContent,
    custom_gpts: CustomGPTsContent,
    community: CommunityContent
}
